<template>
  <div class="spm-data-container">
    <div class="spm-chart">
      <div
        class="d-flex justify-content-center align-items-center chartContainer"
      >
        <apexchart
          type="pie"
          height="250"
          class="chart-box"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
    <div class="spm-table">
      <b-table
        striped
        bordered
        no-border-collapse
        responsive
        :items="items"
        :fields="fields"
      >

      </b-table>
    </div>
  </div>
</template>
<script>
export default {
  name : 'SpmPercentage',
  props: {
    detailId: {
      type: String,
      required: false // true if api ready
    }
  },
  data() {
    return {
      fields:[
       
      ],
      items : [
        { row_labels : 'Tidak Memuaskan', percentage_vendor_category : 89.4, count_vendor_category : 253},
        { row_labels : 'Cukup Memuaskan', percentage_vendor_category : 6.36, count_vendor_category : 18},
        { row_labels : 'Memuaskan', percentage_vendor_category : 3.18, count_vendor_category : 9},
        { row_labels : 'Sangat Memuaskan', percentage_vendor_category : 1.06, count_vendor_category : 3},
      ],
      chartOptions: {
        chart: {
          id : 'SPM Based On Company',
          toolbar : {
            show : false
          },
        },
        title : {
          text : 'SPM Percentage By Score',
          align : 'center'
        },
        labels : [],
        plotOptions: {
          pie: {
            customScale: 1
          }
        }
      },
      series: []
    };
  },
  created(){
      this.chartCategories()
      this.seriesData()
  },
  methods: {
    chartCategories() {
      const self = this
      const dateFormat =  { day: 'numeric', month: 'short', year: 'numeric' }
      let arr = []
      if(self.items){
        self.items.forEach(list => {
          arr.push(list.row_labels)
        })
        self.chartOptions.labels = arr
      } 
    },
    seriesData() {
      const self = this
      let arr = []
      if(self.items){
        self.items.forEach(list => {
          arr.push(list.count_vendor_category)
        })
        self.series = arr
      }
    },
  },
};
</script>
<style lang="scss">
  @import "~/assets/scss/components/dashboard.scss";
</style>
